function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  opacity: 0.1,
  cx: 41,
  cy: 41,
  r: 41,
  fill: "#4293F6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.2553 39.4496C44.9543 39.4496 47.953 36.4388 47.953 32.7248C47.953 29.0108 44.9543 26 41.2553 26C37.5563 26 34.5576 29.0108 34.5576 32.7248C34.5576 36.4388 37.5563 39.4496 41.2553 39.4496Z",
  fill: "#2F66E3"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.5097 56.1559C55.1772 48.5355 50.4256 42.4783 44.6442 42.4783H37.8655C36.7273 42.4806 35.6016 42.7161 34.5572 43.1703C36.0424 45.9388 36.8092 49.0383 36.787 52.1829H27.6C27.2568 53.4814 27.0556 54.8136 27 56.1559H55.5097Z",
  fill: "#2F66E3"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.7876 52.1828C36.8098 49.0383 36.0429 45.9388 34.5577 43.1703C31.3143 44.5543 28.7358 47.9167 27.6006 52.1828H36.7876Z",
  fill: "#2F66E3"
});

var SvgProdCand = function SvgProdCand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProdCand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prod_cand.2431fd03.svg";
export { ForwardRef as ReactComponent };